module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumnail_Unlock.e175b713.jpg";